import { mergeClassNames } from "@cheatsheetz/core-ui";
import type { ComponentProps } from "react";
import { Link } from "react-router-dom";

const focusRing =
  "outline-0 outline-ring/70 outline-offset-2 focus-visible:outline-2 forced-colors:outline-[Highlight]";

const base = `inline-flex cursor-pointer items-center gap-2 rounded-lg text-sm ${focusRing}`;

const intentMap = {
  default: "hover:bg-accent",
  danger: "text-danger hover:bg-danger/10",
  plain: "",
} as const;

const sizeMap = {
  small: "px-3 py-1.5",
  medium: "px-3 py-2",
} as const;

interface NavItemVariants {
  intent?: keyof typeof intentMap;
  size?: keyof typeof sizeMap;
}

interface NavLinkProps extends ComponentProps<typeof Link>, NavItemVariants {}

export function NavLink({
  intent = "default",
  size = "small",
  className,
  ...props
}: NavLinkProps) {
  return (
    <Link
      className={mergeClassNames(base, intentMap[intent], sizeMap[size], className)}
      {...props}
    />
  );
}

interface NavButtonProps
  extends Omit<ComponentProps<"button">, "type">,
    NavItemVariants {}

export function NavButton({
  intent = "default",
  size = "small",
  className,
  ...props
}: NavButtonProps) {
  return (
    <button
      type="button"
      className={mergeClassNames(base, intentMap[intent], sizeMap[size], className)}
      {...props}
    />
  );
}
